import type { SpeedModeScales } from "@slot/presentation";

/** How many times faster than normal turbo and super turbo play this game's round. Tunable. */
export const SPEED_MODE_SCALES: SpeedModeScales = { turbo: 2.25, super_turbo: 4 };
